var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-up 2",
    clipPath: "url(#clip0_35_84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66599 5.42551L1.26244 12.7134C0.905375 13.0649 0.905375 13.6347 1.26244 13.9862L2.12595 14.8362C2.4824 15.1871 3.06012 15.1877 3.41741 14.8377L9.3125 9.06193L15.2075 14.8377C15.5648 15.1878 16.1426 15.1871 16.499 14.8362L17.3625 13.9862C17.7196 13.6347 17.7196 13.0649 17.3625 12.7134L9.95898 5.42555C9.60195 5.07406 9.02305 5.07406 8.66599 5.42551Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0667,
    height: 19.2,
    fill: "white",
    transform: "matrix(-1 -2.62268e-07 -2.62268e-07 1 17.8458 0.530865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.bc67a619c9916e139d6bbef14edf16a6.svg";
export { ForwardRef as ReactComponent };